import AlmeWindow from '@alme/ui-web/modules/window/src/window'
import { settings } from '@alme/ui-web/settings/settings-util'
import render from '@alme/ui-web/modules/window/src/renderers/renderers'
import diff from 'virtual-dom/diff'
import patch from 'virtual-dom/patch'
import createElement from 'virtual-dom/create-element'
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { validateCustomAvatarProperty,validateAvatarIsCustom,getCustomAvatar} from '../custom-avatar/custom-avatar-helper';
export default class CustomAlmeWindowLaunchPoint extends AlmeWindow {
    initWindow() {
        let elm = document.getElementById(this._settings.Window.rootId);
        if (!elm) { //HM-38 If DOM is not loaded, retry in 500ms.
            setTimeout(() => { this.initWindow() }, 500);
            return;
        }

        let tree = render(this._settings, this._mutators, this._childRenderers, this._store?.getState());

        //HM129: Hide logging behind setting. This setting also controls console logging
        let logEnabled = this._settings.logging.enabled || false;

        if (logEnabled) {
            console.log(tree);
        }

        let rootNode = createElement(tree);
        elm.appendChild(rootNode);

        this._windowTree = tree;
        this._isInitialized = true;

        const trapEnabled = this._settings.Window.enableFocusTrap;
        const escapeKey = this._settings.textConstants.escapeKey || settings.textConstants.escapeKey;
        const minimizeiva = this.buildMinimizeOnClick.bind(this);
        const getminimizestate = this.getMinimizeState.bind(this);
        if (trapEnabled) {
            const focusableElements =
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const modal: any = document.querySelector(`#${this._settings.Window.rootId}`);

            document.addEventListener('keydown', function (e) {
                const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed && e.key != escapeKey) {
                    return;
                }
                const focusableContent = modal.querySelectorAll(focusableElements);
                const visibleContent: any = [];

                for (let i = 0, max = focusableContent.length; i < max; i++) {
                    const el = focusableContent[i];
                    const style = window.getComputedStyle(el);
                    if (!((style.display === 'none') || (style.visibility === 'hidden') || (!el.offsetHeight && !el.offsetWidth) || el.disabled === true))
                        visibleContent.push(el);
                }

                if (visibleContent.length > 1) {
                    const lastFocusableElement: any = visibleContent[visibleContent.length - 1];
                    const firstFocusableElement: any = visibleContent[0];

                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus();
                            e.preventDefault();
                        }
                    }
                    else if (e.key === escapeKey) {

                        if (visibleContent.includes(document.activeElement)) {
                            if (getminimizestate() == false) {
                                minimizeiva();
                                (document.getElementsByClassName(settings.classNames.launchPointText)[0] as HTMLElement).focus();
                            }
                        }

                    }
                    else {
                        if (document.activeElement === lastFocusableElement) {
                            firstFocusableElement.focus();
                            e.preventDefault();
                        }
                    }
                }

            });
        }
    }
    getPayload() {
        let payloadBase;
        if (window.enableIVAasService) {
            if (window.sessionStorage?.ivaServiceJsonData) {
                payloadBase = JSON.parse(window.sessionStorage?.ivaServiceJsonData);
            }
            else {
                payloadBase = window.enableIVAasService();
            }
        }
        else if(window.enableIVA2Features) {
            payloadBase = window.enableIVA2Features();
        }
        return payloadBase;
    }

    renderWindow() {
        if (!this._store?.getState()?.Window?.IsEmbedded) {
            const alightSettings = this._settings as AlightCustomSettingsType;
            if (!this._isInitialized) return;
            const box = document.createElement("div");
            box.classList.add(alightSettings.classNames.launchPointIconAvatar);
            let rootDiv = document.getElementById(this._settings.Window.rootId)?.lastElementChild as HTMLElement;
            const deviceType = this._store?.getState().DeviceType;
            const className = (deviceType === this._settings.mobileConstants.deviceTypes.tablet)
                ? this._settings.classNames.launchPointContainerTablet
                : this._settings.classNames.launchPointContainer;
            rootDiv.className = className;
            let currentTree = this._windowTree;

            currentTree.properties.className = className;
            let newTree = render(this._settings, this._mutators, this._childRenderers, this._store?.getState());
            newTree.properties.className = className;
            let patches = diff(currentTree, newTree);
            if (rootDiv) {
                patch(rootDiv, patches);
            }
            let rp = document.getElementsByClassName(alightSettings.classNames.launchPointIconBackground);
            let bp = document.getElementsByClassName(alightSettings.classNames.launchPointIconAvatar);
            if (rp.length > 0 && bp.length == 0) {
                rp[0].after(box);
            }
            let newAvatar;
            let payloadBase = this.getPayload();
            if (validateCustomAvatarProperty(payloadBase)) {
                newAvatar = getCustomAvatar(payloadBase)
            }
            if (this.getMinimizeState() == false) {
                let elemt = document.getElementsByClassName(`${alightSettings.classNames.launchPoint} ${alightSettings.classNames.launchPointHype}`);
                if (elemt.length > 0) {
                    elemt[0].className = `${alightSettings.classNames.launchPoint}`;
                }
                if (validateAvatarIsCustom(newAvatar, this._settings)) {
                    if (newAvatar) {
                        let elemt_avatar = document.getElementsByClassName(`${alightSettings.classNames.launchPointIconAvatar}`) as HTMLCollectionOf<HTMLElement>;
                        if (elemt_avatar.length > 0) {
                            elemt_avatar[0].style.backgroundImage = `url("${newAvatar}")`;
                            elemt_avatar[0].style.backgroundSize = newAvatar ? '70px' : '50%'
                            elemt_avatar[0].style.backgroundRepeat = 'no-repeat';
                        }
                    }
                }
            }
            this._windowTree = newTree;
            var launchpointdiv: any = document.getElementsByClassName(className);
            for (let i = 0; i < launchpointdiv.length; i++) {
                let element = launchpointdiv[i];
                element.removeAttribute("tabindex");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./modules/custom-window-launchpoint/customwindowlaunchpoint.ts